import React, { useState, useContext } from 'react';
import styles from './typeChangeBtnGroup.less?modules';
import { isEmptyObject } from '@/utils/comUtil';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { TypeChangeBtnGroupStyled } from './TypeChangeBtnGroupStyled';

const TypeChangeBtnGroup = (props) => {
  const [check, setCheck] = useState(null);
  const [checkedIndex, setCheckedIndex] = useState(props.checkedIndex || 0);
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const handleChange = (i, v) => {
    setCheck(v);
    setCheckedIndex(i);
    props.change && props.change(v);
  };
  const { typeList } = props;
  return (
    <div className={styles.dimSwitch} style={props.style}>
      {!isEmptyObject(typeList) &&
        typeList.map((item, i) => {
          return (
            <TypeChangeBtnGroupStyled
              theme={themeContext}
              className={styles.box}
              brand={brandContext}
              key={i}
            >
              <label
                className={checkedIndex === i ? 'checked' : 'unchecked'}
                key={i}
              >
                <input
                  type="radio"
                  name="type"
                  value={item.value}
                  checked={check === item.value}
                  onChange={() => {
                    handleChange(i, item.value);
                  }}
                />
                {item.label}
              </label>
            </TypeChangeBtnGroupStyled>
          );
        })}
    </div>
  );
};
export default TypeChangeBtnGroup;
